import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import DOMPurify from "dompurify";

const FAQs = ({ package_faqs, customStyle = {} }) => {
  if (!customStyle?.isFAQsEnabled) return null;

  if (package_faqs.length === 0) return null; // force to hide no faqs

  return (
    <Box sx={{ mt: "24px" }}>
      <Box>
        <Typography
          sx={{
            color: customStyle?.textColor ?? "#19181B",
            fontSize: "22px",
            lineHeight: "22px",
            fontFamily: `var(--font-${customStyle?.headingFont})`,
          }}
        >
          {" "}
          FAQs{" "}
        </Typography>
      </Box>

      {package_faqs.length === 0 && (
        <Box
          sx={{
            p: "24px",
            border: "1px solid #DFE2E6",
            backgroundColor: "#F2F2F2",
            borderRadius: "12px",
            mt: "24px",
          }}
        >
          <Typography
            sx={{
              color: customStyle?.secondaryTextColor ?? "#878787",
              fontFamily: `var(--font-${customStyle?.bodyFont})`,
              textAlign: "center",
            }}
          >
            No FAQs available for this package.
          </Typography>
        </Box>
      )}

      {package_faqs.length > 0 && (
        <Box>
          <Box
            sx={{
              mt: "32px",
              border: "1px solid #DFE2E6",
              ...(customStyle?.borderColor && {
                border: `1px solid ${customStyle?.borderColor}`,
              }),
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            {package_faqs.map((data, key) => {
              return (
                <Accordion
                  key={key}
                  elevation={0}
                  sx={{
                    "&.Mui-expanded": {
                      m: "0px !important",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <IconButton sx={{ border: "1px solid #DFE2E6" }}>
                        <ExpandMore />
                      </IconButton>
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      p: "10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: `var(--font-${customStyle?.headingFont})`,
                        fontSize: "18px",
                        lineHeight: "22px",
                        fontWeight: 500,
                        color: customStyle?.textColor ?? "#19181B",
                      }}
                    >
                      {data.question}
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      px: "10px !important",
                    }}
                  >
                    <Typography
                      className="no-margin"
                      sx={{
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: customStyle?.textColor ?? "#19181B",
                        fontFamily: `var(--font-${customStyle?.bodyFont})`,
                      }}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data.answer),
                      }}
                    ></Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FAQs;
